var laptop = "https://shopfront-cdn.tekoapis.com/static/86553a12f72c9c94.svg";

export { laptop as default };
